<template>
  <svg class="svg-map-marker" xmlns="http://www.w3.org/2000/svg" width="22" height="31" viewBox="0 0 22 31" fill="none">
    <path d="M14 29C14 30.1046 12.6569 31 11 31C9.34315 31 8 30.1046 8 29C8 27.8954 9.34315 27 11 27C12.6569 27 14 27.8954 14 29Z" fill="#B7BBC2"/>
    <path d="M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11Z" stroke-width="1" stroke="var(--rd-marker-border-color)" :fill="`${color}`"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z" fill="var(--rd-marker-border-color)"/>
    <path d="M15 11C15 13.2091 13.2091 15 11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11Z" fill="var(--rd-marker-border-color)"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 29V21.5H12V29C12 29.5523 11.5523 30 11 30C10.4477 30 10 29.5523 10 29Z" fill="var(--rd-marker-border-color)"/>
  </svg>
</template>

<script>
export default {
  name: 'mapMarkerSVG',
  props: {
    color: {
      type: String,
      default: 'var(--rd-map-marker-color)',
    },
  }
}
</script>

<style>
  .svg-map-marker {
    --rd-map-marker-color: #53565A;
    --rd-map-marker-color-selected: #83878D;
    --rd-marker-border-color: #FCFDFD;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.00) inset;

    &:hover {
      --rd-map-marker-color: #686C72;
    }
  }
</style>
